import { memo } from 'react';

import useMatch from '../../MatchUnit/useMatch';

import CommonStandings from '@shared/Standings';
import type { Match } from '@shared-types/match.types';

const Standings = ({ options }: { options: { match: Match } }) => {
  const match = useMatch(options.match);
  const groupId = match?.group?.id;

  return <CommonStandings options={options} groupId={groupId} boxed newTableFormat />;
};

export default memo(Standings);
